"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReinstateClauseInputSchema = exports.RetireClauseInputSchema = exports.RecordClauseReplacementInputSchema = exports.SupersedeClauseInputSchema = exports.ClauseReplacementSchema = exports.ExistingClauseReplacementSchema = exports.NewClauseReplacementSchema = exports.ClauseReplacementKindSchema = exports.ClauseReplacementKind = exports.ReviseClauseWordingInputSchema = exports.CreateClauseInputSchema = exports.ListCurrentClausesInputSchema = void 0;
const z = require("zod");
const property_key_1 = require("../Consensus/property-key");
const spec_handle_1 = require("./spec-handle");
exports.ListCurrentClausesInputSchema = z.object({
    propertyKeys: z
        .array(property_key_1.PropertyKeySchema)
        .optional()
        .describe('Package-data properties to restrict the specification to. Omit to read every property.'),
    includeRetired: z
        .boolean()
        .optional()
        .describe('Include clauses that have been retired or superseded. Defaults to false.'),
    includePriorVersions: z
        .boolean()
        .optional()
        .describe('Include the superseded wordings of each clause alongside the one in force. Defaults to false.'),
    search: z
        .string()
        .optional()
        .describe('Free-text term matched case-insensitively against clause short names and wording.'),
});
exports.CreateClauseInputSchema = z.object({
    propertyKey: property_key_1.PropertyKeySchema,
    shortName: spec_handle_1.SpecHandleSchema,
    description: z.string().min(1),
});
exports.ReviseClauseWordingInputSchema = z.object({
    clauseId: z.string(),
    shortName: spec_handle_1.SpecHandleSchema.optional(),
    description: z.string().min(1).optional(),
});
var ClauseReplacementKind;
(function (ClauseReplacementKind) {
    ClauseReplacementKind["NewClause"] = "new_clause";
    ClauseReplacementKind["ExistingClause"] = "existing_clause";
})(ClauseReplacementKind || (exports.ClauseReplacementKind = ClauseReplacementKind = {}));
exports.ClauseReplacementKindSchema = z.nativeEnum(ClauseReplacementKind);
exports.NewClauseReplacementSchema = z.object({
    kind: z.literal(ClauseReplacementKind.NewClause),
    draft: exports.CreateClauseInputSchema,
});
exports.ExistingClauseReplacementSchema = z.object({
    kind: z.literal(ClauseReplacementKind.ExistingClause),
    clauseId: z.string(),
});
exports.ClauseReplacementSchema = z.discriminatedUnion('kind', [
    exports.NewClauseReplacementSchema,
    exports.ExistingClauseReplacementSchema,
]);
exports.SupersedeClauseInputSchema = z.object({
    clauseId: z.string(),
    replacement: exports.ClauseReplacementSchema,
    retirementComment: z.string().optional(),
});
exports.RecordClauseReplacementInputSchema = z.object({
    clauseId: z.string(),
    replacementClauseId: z.string(),
});
exports.RetireClauseInputSchema = z.object({
    clauseId: z.string(),
    retirementComment: z.string().optional(),
});
exports.ReinstateClauseInputSchema = z.object({
    clauseId: z.string(),
});
//# sourceMappingURL=package-data-spec-clause.inputs.js.map